// 수신자료관리 - CLAIM정보자료조회
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const RNTW0 = lazy(() => import('@/pages/B05/RNTW0'));  // 클레임

function B05() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/B05/RNTW0" component={RNTW0} />
      </Switch>
    </Suspense>
  );
}

export default B05;
